import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { InformationDialogComponent } from './components/information-dialog/information-dialog.component';
import { DamComponent } from './components/dam/dam.component';

import { MscModule, MscAssetBrowserModule, MscService } from 'msc';
import { MwcEmptyStateComponent } from './components/mwc-empty-state/mwc-empty-state.component';
import { MwcButtonModule } from 'mwc/button';
import { MwcIconModule } from 'mwc/icon';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcSpinModule } from 'mwc/spin';
import { CustomTemplateWorkflowModule } from './components/custom-template-workflow/custom-template-workflow.module';
import { MwcDropDownModule } from 'mwc/dropdown';
import { MwcModalModule } from 'mwc/modal';
import { MwcGridModule } from 'mwc/grid';
import { MwcCardModule } from 'mwc/card';
import { DeleteConfirmationComponent } from './components/delete-confirmation/delete-confirmation.component';
import { ArticlePerformanceReviewComponent } from './components/article-performance-review/article-performance-review.component';
//import { FolderListService } from 'msc/lib/modules/asset-browser/services/folder-list.service';

@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    InformationDialogComponent,
    DamComponent,
    MwcEmptyStateComponent,
    DeleteConfirmationComponent,
    ArticlePerformanceReviewComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MscModule,
    MscAssetBrowserModule,
    MwcButtonModule,
    MwcIconModule,
    MwcOutletModule,
    MwcSpinModule,
    CustomTemplateWorkflowModule,
    MwcDropDownModule,
    MwcModalModule,
    MwcGridModule,
    MwcCardModule
  ],
  providers: [
    MscService,
    //FolderListService,
  ],
  exports: [
    ConfirmationDialogComponent,
    DamComponent,
    MwcEmptyStateComponent,
    DeleteConfirmationComponent,
    ArticlePerformanceReviewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedUiModule {}
